/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type CardDtoStatus = typeof CardDtoStatus[keyof typeof CardDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardDtoStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  ACTIVATION_PENDING: 'ACTIVATION_PENDING',
  ACTIVATION_FAILED: 'ACTIVATION_FAILED',
  BLOCKED: 'BLOCKED',
  BLOCKING_PENDING: 'BLOCKING_PENDING',
  BLOCKING_FAILED: 'BLOCKING_FAILED',
  OUT_OF_USE: 'OUT_OF_USE',
  CANCELLED: 'CANCELLED',
} as const;
